export const BillingSystem = Object.freeze({
  CCP: 'CCP',
  HAMS: 'HAMS'
});